module.exports = __webpack_public_path__ + "img/delete-icon.6ef2d2b7.svg";